import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

import {PAContextProvider} from "./Services/PAContext";
import {GoogleOAuthProvider} from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <BrowserRouter>
      <PAContextProvider>
          <GoogleOAuthProvider clientId="1070636036545-ej8890jongjmkta7uc9k6b58m2rcl9ht.apps.googleusercontent.com">
              <App />
          </GoogleOAuthProvider>
      </PAContextProvider>
    </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
